import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myStudioService } from '../StudioService/StudioService.connected';
import { createArrivalListService } from './ArrivalListService.impl';

export const myArrivalListService = createArrivalListService({
  services: {
    studioService: myStudioService,
    errorService: myErrorService
  }
});
